import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { SERVER_API_URL } from "../server/server";
import { useNavigate } from "react-router-dom";
import { UserContaxt } from "../../src/store/userData";
import axios from "axios";

export const Navigation = (props) => {
  const navigate = useNavigate();
  const { setUserData } = useContext(UserContaxt)

  const handleLogout = async () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");

    if (!confirmLogout) return; // ❌ user clicked NO

    try {
      const response = await axios.get(`${SERVER_API_URL}/api/users/logout`);

      if (response.status === 200) {
        localStorage.removeItem("global_user_token");
        setUserData(null);

        navigate("/login");
      }

    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <Link to="/">
            <a className="navbar-brand page-scroll" href="#page-top">
              Admin
            </a>
          </Link>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                Features
              </a>
            </li>
            {/* <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li> */}
            <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li>
            {/* <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li> */}
            {/* <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li> */}
            {/* <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li> */}
            <li>
              <a href="/users" className="page-scroll">
                Team
              </a>
            </li>

            {/* <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li> */}
            {/* <li>
              <a href="#testimonials" className="page-scroll">
                Transaction
              </a>
            </li> */}

            <li>
              <a href="/fund-status" className="page-scroll">
                Status
              </a>
            </li>

            <li>
              <a href="/scanner" className="page-scroll">
                Scanner
              </a>
            </li>

            <li>
              <a href="#" className="page-scroll" onClick={()=>handleLogout()}>
                Logout
              </a>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
};
